import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=362f001f"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=362f001f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362f001f')) {
      api.createRecord('362f001f', component.options)
    } else {
      api.reload('362f001f', component.options)
    }
    module.hot.accept("./OrderStatus.vue?vue&type=template&id=362f001f", function () {
      api.rerender('362f001f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/OrderStatus.vue"
export default component.exports